import { render, staticRenderFns } from "./Consumi.vue?vue&type=template&id=5b0052b6&scoped=true"
import script from "./Consumi.vue?vue&type=script&lang=ts"
export * from "./Consumi.vue?vue&type=script&lang=ts"
import style0 from "./Consumi.vue?vue&type=style&index=0&id=5b0052b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0052b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0052b6')) {
      api.createRecord('5b0052b6', component.options)
    } else {
      api.reload('5b0052b6', component.options)
    }
    module.hot.accept("./Consumi.vue?vue&type=template&id=5b0052b6&scoped=true", function () {
      api.rerender('5b0052b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Consumi.vue"
export default component.exports